'use strict';

var ListItem = require('../ListItem');
var getUserLinks = require('../links/user-links');

function renderUserListItems(depsArg) {
	var userLinks = getUserLinks.renderUserLinks(depsArg);

	return {

		renderSubscriptionListItem: function render(config, deps) {
			return (new ListItem({
				linkComponent: userLinks.renderSubscriptionLink(config, deps),
				className: 'ad-component_list-item--subscription'
			})).render(config, deps);
		},

		renderCompanyListItem: function render(config, deps) {
			return (new ListItem({
				linkComponent: userLinks.renderCompanyLink(config, deps),
				className: 'ad-component_list-item--company'
			})).render(config, deps);
		},

		renderProfileListItem: function render(config, deps) {
			return (new ListItem({
				linkComponent: userLinks.renderProfileLink(config, deps),
				className: 'ad-component_list-item--profile'
			})).render(config, deps);
		},

		renderSettingsListItem: function render(config, deps) {
			return (new ListItem({
				linkComponent: userLinks.renderSettingsLink(config, deps),
				className: 'ad-component_list-item--settings'
			})).render(config, deps);
		},

		renderMobileSwitchListItem: function render(config, deps) {
			return (new ListItem({
				linkComponent: userLinks.renderMobileSwitchLink(config, deps),
				className: 'ad-component_list-item--mobile-switch'
			})).render(config, deps);
		}
	};
}

module.exports = {
	renderUserListItems: renderUserListItems
};



//////////////////
// WEBPACK FOOTER
// ./~/ad-theme-customizer-client/src/components/views/list-items/user-list-items.js
// module id = 17
// module chunks = 0